export const setdelete = () => ({
    type: 'SET_DELETE',
});